import React from "react";

const MyText = ({
  children,
  color,
  size = "1.5rem",
  fontFamily,
  marginBottom,
  marginTop,
  marginRight,
  width,
  direction,
}) => {
  return (
    <span
      style={{
        color,
        fontSize: size,
        fontFamily,
        marginBottom,
        marginTop,
        marginRight,
        direction,
      }}
    >
      {children}
    </span>
  );
};

export { MyText };
